import storeRoot from "./store-root";
import account from "./modules/account";
import pond from "./modules/pond";
import cultureCycle from "./modules/cultureCycle";
import user from "./modules/user";
import fryPurchase from "./modules/fryPurchase";
import fish from "./modules/fish";
import fishSales from "./modules/fishSales";
import fishLoss from "./modules/fishLoss";
import turnPond from "./modules/turnPond";
import proofing from "./modules/proofing";
import feeding from "./modules/feeding";
import prevent from "./modules/prevent";
import base from "./modules/base";
import provider from "./modules/provider";
import customer from "./modules/customer";
import dataDict from "./modules/dataDict";
import report from "./modules/report";
import area from "./modules/area";
import storeHouse from "./modules/storeHouse";
import expense from "./modules/expense";
import permission from "./modules/permission";
import waterQualityParameter from "./modules/waterQualityParameter";
import homeReport from "./modules/homeReport";
import qualityCheck from "./modules/qualityCheck";
import driverManage from "./modules/driverManage";
import circulationBusiness from "./modules/circulationBusiness";
import qualityTracing from "./modules/qualityTracing";
import productionPlan from "./modules/productionPlan";
import cultureBreed from "./modules/cultureBreed";
import materialSetting from "./modules/materialSetting";
import materialPurchase from "./modules/materialPurchase";
import personManagement from "./modules/personManagement";
import userManage from "./modules/userManage";
import roleSetting from "./modules/roleSetting";
import inOutReport from "./modules/inOutReport";
import costOriginValue from "./modules/costOriginValue";
import purchase from "./modules/purchase"; //采购入库单
import batch from "./modules/batch"; //批次
import warehouse from "./modules/warehouse";
import vehicle from "./modules/vehicle";
import employee from "./modules/employee"; //员工
import supplier from "./modules/supplier"; // 供应商
import product from "./modules/product"; // 供应商
import weighing from "./modules/weighing"; //称重
import finance from "./modules/finance"; //财务(收款，付款单)
import duiZhuang from "./modules/duiZhuang";
import entryCheck from "./modules/entryCheck"; //入境登记单
import warehouseT from "./modules/wareHouseT";
import card from "./modules/card";
var storeInterface = storeRoot;
var modulesInterface = {
  account,
  pond,
  cultureCycle,
  user,
  fryPurchase,
  fish,
  fishSales,
  fishLoss,
  turnPond,
  proofing,
  feeding,
  prevent,
  base,
  provider,
  customer,
  dataDict,
  report,
  area,
  storeHouse,
  expense,
  waterQualityParameter,
  permission,
  homeReport,
  qualityCheck,
  driverManage,
  circulationBusiness,
  qualityTracing,
  productionPlan,
  cultureBreed,
  materialSetting,
  materialPurchase,
  personManagement,
  userManage,
  roleSetting,
  inOutReport,
  costOriginValue,
  warehouse,
  vehicle,
  purchase,
  batch,
  employee,
  supplier,
  product,
  weighing,
  finance,
  duiZhuang,
  entryCheck,
  warehouseT,
  card,
};

export var store = storeInterface;
export var modules = modulesInterface;
